import React from "react";

import {isIe11} from "utils/browser_test";
import getZoomedFontSize from "utils/get_zoomed_font_size";
import {shouldUseManualCorrections} from "utils/manual_corrections_utils";
import issueHeaderUtils from "utils/issues/issue_header_utils";
import Markdown from "common_components/markdown";
import {replaceClauseObjectsWithTags} from "./utils/clause_links/replace_clause_objects_with_tags";
import OtherDocumentClauseLink from "./components/other_document_clause_link";
import getFamilyDocumentId from "modules/documents/utils/get_family_document_id";

const styles = {
  reason: {
    color: "#474747",
    marginTop: "0.2rem",
    overflowWrap: "break-word",
    ...(isIe11() ? {width: "100%"} : {}),
  },
};

function isReasonTextArrayEmpty(reasonTextArray) {
  if (!reasonTextArray) {
    return true;
  }
  const nonEmptyItems = reasonTextArray.filter(
    item => item && item.trim().length,
  );
  return !nonEmptyItems.length;
}

export function ClauseLink({hasFailed, text, data, scrollToClause}) {
  if (hasFailed) {
    return <span>{text}</span>;
  }
  return (
    <span
      onClick={() => scrollToClause(data)}
      style={{cursor: "pointer", textDecoration: "underline"}}
    >
      {text}
    </span>
  );
}

function DetailedReason(props) {
  const {isFlipChecklistIcons} = props;
  const text = getDetailText(props, true);
  return (
    <div
      style={{
        backgroundColor: "#efefef",
        padding: "12px 20px",
        border: "1px solid #bbb",
        margin: "0.5rem",
        fontSize: getZoomedFontSize(15, "checklist", props.zoom),
        flexShrink: 0,
      }}
    >
      <div
        style={{
          color: isFlipChecklistIcons ? "#333333" : "#42a5f5",
          fontWeight: isFlipChecklistIcons ? "normal" : "bold",
          padding: "0.5rem 0 1rem 0",
          borderBottom: "1px solid #d3d3d3",
          marginBottom: "0.5em",
        }}
      >
        Overview
      </div>
      <div style={styles.reason} data-testid="detailed_reason">
        <Markdown
          ignoreLegacy={props.issue.trigger_type === "LLM"}
          components={{
            clauselink: ({data}) => {
              const {
                hasFailed,
                text,
                data: clauseData,
                otherDocument,
              } = JSON.parse(decodeURIComponent(data));
              if (otherDocument) {
                return (
                  <OtherDocumentClauseLink
                    text={text}
                    clause={otherDocument}
                    organisationId={props.organisationId}
                    projectId={props.project.id}
                  />
                );
              }
              return (
                <ClauseLink
                  hasFailed={hasFailed}
                  text={text}
                  data={clauseData}
                  scrollToClause={props.scrollToClause}
                />
              );
            },
          }}
        >
          {text}
        </Markdown>
      </div>
    </div>
  );
}

function buildReasonText(props, useAnnotated) {
  const reasonTextArray = issueHeaderUtils.getReasonTextArray(
    props.issue,
    props.documentClauses,
    props.topicsById,
    props.positiveReasonData,
    props.selectedReport,
    props.currentIssuesetItem,
    props.documentClauseparts,
    props.document.parties,
    true,
    true,
    shouldUseManualCorrections(
      "detailed_reason",
      props.project,
      props.selectedReport,
    ),
    props.preventMemo,
    false,
    useAnnotated,
  );
  if (isReasonTextArrayEmpty(reasonTextArray)) {
    return null;
  }
  return reasonTextArray.join("\n");
}

export function getRawReasonText(props) {
  return buildReasonText(props, true);
}

function getDetailText(props, useAnnotated) {
  if (useAnnotated) {
    const text = getRawReasonText(props);
    if (!text) {
      return null;
    }
    try {
      return replaceClauseObjectsWithTags(
        text,
        props.documentClauseparts,
        props.documentSections,
        getFamilyDocumentId(props.document),
      );
    } catch (err) {
      return buildReasonText(props, false);
    }
  }
  return buildReasonText(props, false);
}

export default DetailedReason;
